import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DmtService } from 'src/app/services/dmt.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-load-money',
  templateUrl: './load-money.component.html',
  styleUrls: ['./load-money.component.scss']
})
export class LoadMoneyComponent implements OnInit {
  isloading: boolean;
  verified: boolean=false;
  getData: any;
  ymLogoPng: any;
  constructor(
    public dialogRef: MatDialogRef<LoadMoneyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dmtServices: DmtService,
    private toastr: ToastrService,
    private ngxService: NgxUiLoaderService,

    ) { 
      this.ymLogoPng=environment.ym_logo_png;
   
  }

  ngOnInit(): void {
    console.log("in money load component:::", this.data);
  }

  cancel(){
    this.dialogRef.close();
  }
  proceed(){
    this.ngxService.start();
    console.log(this.data.Accdetails.mobile)
    this.dmtServices.accountDetailsVerify(this.data).subscribe((res:any)=>{
    this.ngxService.stop();

    if(res.status_code==1){
      this.verified=true;
      this.getData=this.data.Accdetails;
      this.toastr.success(res.message);
      if(res.object.data){
        this.updateBeneNameApi(res.object.data.nameAtBank);
        this.bankverifyUpdateApi();

      }
    }else{
      this.toastr.error(res.error.message);

    }
    this.ngxService.stop();
    console.log(res);

    },err=>{
      console.log(err);
      this.ngxService.stop();
      this.toastr.error(err.error.message);

    })
    // this.dialogRef.close();
   
  }

  bankverifyUpdateApi(){
  this.dmtServices.bankverifyUpdate(this.data).subscribe((res:any)=>{
    console.log(res);
  },err=>{
    console.log(err);
  })
}
  updateBeneNameApi(nameOnBank){
    this.dmtServices.updatebeneDetailsAfterVerification(nameOnBank,this.data).subscribe((res:any)=>{
      console.log(res);
    },err=>{
      console.log(err);
    })
  }
  
}
